"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = function Search(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M18 5.5H6C5.93433 5.49995 5.86929 5.51285 5.8086 5.53796C5.74792 5.56307 5.69278 5.5999 5.64634 5.64634C5.5999 5.69278 5.56307 5.74792 5.53796 5.8086C5.51285 5.86929 5.49995 5.93433 5.5 6V18C5.5 18.1326 5.55268 18.2598 5.64645 18.3536C5.74021 18.4473 5.86739 18.5 6 18.5H18C18.1326 18.5 18.2598 18.4473 18.3536 18.3536C18.4473 18.2598 18.5 18.1326 18.5 18V6C18.5 5.86739 18.4473 5.74021 18.3536 5.64645C18.2598 5.55268 18.1326 5.5 18 5.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M19.3528 18.6463L17.3528 16.6463C17.3501 16.6436 17.3472 16.6415 17.3446 16.6389L15.5136 14.8079C16.1529 14.0118 16.5009 13.0211 16.5 12C16.5 9.51869 14.4813 7.5 12 7.5C9.51869 7.5 7.5 9.51869 7.5 12C7.5 14.4813 9.51869 16.5 12 16.5C13.0207 16.501 14.0111 16.1532 14.8071 15.5144L16.6464 17.3536C16.649 17.3564 16.6519 17.3585 16.6545 17.361L18.6464 19.3528C18.7405 19.444 18.8668 19.4946 18.998 19.4936C19.1291 19.4925 19.2546 19.44 19.3473 19.3473C19.44 19.2545 19.4926 19.1291 19.4936 18.9979C19.4946 18.8668 19.444 18.7405 19.3528 18.6463ZM12 15.5C11.3078 15.5 10.6311 15.2947 10.0555 14.9101C9.47993 14.5256 9.03133 13.9789 8.76642 13.3394C8.50152 12.6999 8.4322 11.9961 8.56725 11.3172C8.7023 10.6382 9.03564 10.0146 9.52513 9.52513C10.0146 9.03564 10.6383 8.7023 11.3172 8.56725C11.9961 8.4322 12.6999 8.50152 13.3394 8.76642C13.9789 9.03133 14.5256 9.47993 14.9101 10.0555C15.2947 10.6311 15.5 11.3078 15.5 12C15.499 12.9279 15.1299 13.8176 14.4737 14.4737C13.8176 15.1299 12.9279 15.499 12 15.5Z",
    fill: props.foregroundColor
  }));
};

Search.defaultProps = {
  altText: "Search",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Search.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Search;
exports.default = _default;